// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"bc95c9c8","44":"331d5779","118":"1df6419f","223":"a5629a3c","343":"3f243e0a","453":"3cb1ae6e","483":"23443f4b","489":"2a3e9eaa","569":"b4b349cc","862":"6b824b52","900":"de78ea00","939":"cf24bf8a"}[chunkId] + ".chunk.js";
};